module.exports = __webpack_public_path__ + "img/contact_map_01.e1170d9b.jpg";